module.exports = __webpack_public_path__ + "static/logo-heading-dd4b954fe72f20f623ba4c7e1ae2e872.png";